import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslatePipe } from '@ngx-translate/core';
import { Tooltip } from 'primeng/tooltip';
import { ScreenResolutionService } from '@app/core/services/screen-resolution/screen-resolution.service';
import { FloatingPopupService } from '@app/main/main-content/floating-popup-manager/services/floating-popup.service';
import { FloatingPopupChartThresholdColorActionComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-chart-threshold-color-action/floating-popup-chart-threshold-color-action.component';
import { isEnvFeatureEnabled } from '@app/core/env-feature/env-feature';
import { EnvType } from 'src/environments/common/environment-type.enum';

@Component({
  selector: 'gc-floating-popup-content-chart-actions',
  standalone: true,
  imports: [ButtonModule, SvgIconComponent, TranslatePipe, Tooltip, FloatingPopupChartThresholdColorActionComponent],
  templateUrl: './floating-popup-content-chart-actions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FloatingPopupContentChartActionsComponent {
  public readonly scrRes = inject(ScreenResolutionService);
  public readonly service: FloatingPopupService = inject(FloatingPopupService);

  public showThresholdColor = input<boolean>(false);
  public isLabelsHidden = input<boolean>(false);
  public isChartFullscreen = input.required<boolean>();
  public chartFullscreen = output<boolean>();

  protected readonly detailsBtnAvailable = isEnvFeatureEnabled([EnvType.Development, EnvType.Test]);

  toggleFullscreen() {
    this.chartFullscreen.emit(!this.isChartFullscreen());
  }
}
